export const CHANGE_PATIENT_NUMBER = "patient/CHANGE_PATIENT_NUMBER";
export const SELECTED_PATIENT = "patient/SELECTED_PATIENT";
export const SELECTED_PATIENT_DETAIL = "patient/SELECTED_PATIENT_DETAIL";
export const TOGGLE_MODAL_CONFIRM = "patient/TOGGLE_MODAL_CONFIRM";
export const RESET_MODAL_CONFIRM = "patient/RESET_MODAL_CONFIRM";
export const CHECK_CONFIRM = "patient/CHECK_CONFIRM";
export const RESET_CONFIRM_CHECK = "patient/RESET_CONFIRM_CHECK";
export const CLEAR_STATE = "patient/CLEAR_STATE";
export const RESET_DATA = "patient/RESET_DATA";

export const GET_PATIENT_BY_USERID_REQUEST =
  "patient/GET_PATIENT_BY_USERID_REQUEST";
export const GET_PATIENT_BY_USERID_SUCCESS =
  "patient/GET_PATIENT_BY_USERID_SUCCESS";
export const GET_PATIENT_BY_USERID_FAILURE =
  "patient/GET_PATIENT_BY_USERID_FAILURE";

export const GET_PATIENT_BY_MSBN_REQUEST =
  "patient/GET_PATIENT_BY_MSBN_REQUEST";
export const GET_PATIENT_BY_MSBN_SUCCESS =
  "patient/GET_PATIENT_BY_MSBN_SUCCESS";
export const GET_PATIENT_BY_MSBN_FAILURE =
  "patient/GET_PATIENT_BY_MSBN_FAILURE";
export const RESET_FORM_GET_PATIENT_BY_MSBN =
  "patient/RESET_FORM_GET_PATIENT_BY_MSBN";

export const INSERT_PATIENT_REQUEST = "patient/INSERT_PATIENT_REQUEST";
export const INSERT_PATIENT_SUCCESS = "patient/INSERT_PATIENT_SUCCESS";
export const INSERT_PATIENT_FAILURE = "patient/INSERT_PATIENT_FAILURE";

export const DELETE_PATIENT_REQUEST = "patient/DELETE_PATIENT_REQUEST";
export const DELETE_PATIENT_SUCCESS = "patient/DELETE_PATIENT_SUCCESS";
export const DELETE_PATIENT_FAILURE = "patient/DELETE_PATIENT_FAILURE";

export const SEARCH_PATIENT_BY_INFO_REQUEST =
  "patient/SEARCH_PATIENT_BY_INFO_REQUEST";
export const SEARCH_PATIENT_BY_INFO_REQUEST_SUCCESS =
  "patient/SEARCH_PATIENT_BY_INFO_REQUEST_SUCCESS";
export const SEARCH_PATIENT_BY_INFO_REQUEST_FAILURE =
  "patient/SEARCH_PATIENT_BY_INFO_REQUEST_FAILURE";

export const SHOW_LOADING = "patient/SHOW_LOADING";
export const HIDE_LOADING = "patient/HIDE_LOADING";

// export  const  GET_CLS_SEARCH_HISTORY_REQUEST = "patient/GET_CLS_SEARCH_HISTORY_REQUEST";
// export  const  GET_CLS_SEARCH_HISTORY_SUCCESS = "patient/GET_CLS_SEARCH_HISTORY_SUCCESS";
// export  const  GET_CLS_SEARCH_HISTORY_FAILURE = "patient/GET_CLS_SEARCH_HISTORY_FAILURE";

export const UMC_CHOOSE_PATIENT_LIST_REQUEST =
  "patient/@@UMC_CHOOSE_PATIENT_LIST_REQUEST";
export const UMC_CHOOSE_PATIENT_LIST_REQUEST_SUCCESS =
  "patient/@@UMC_CHOOSE_PATIENT_LIST_REQUEST_SUCCESS";
export const UMC_CHOOSE_PATIENT_LIST_REQUEST_FAIL =
  "patient/@@UMC_CHOOSE_PATIENT_LIST_REQUEST_FAIL";

// choose patient

export const TOGGLE_MODAL_CHOOSE_PATIENT =
  "patient/TOGGLE_MODAL_CHOOSE_PATIENT";
export const RESET_MODAL_CHOOSE_PATIENT = "patient/RESET_MODAL_CHOOSE_PATIENT";
export const SELECTED_PATIENT_AFTER_CREATE =
  "patient/SELECTED_PATIENT_AFTER_CREATE";
export const UPDATE_SELECTED_PATIENT = "patient/UPDATE_SELECTED_PATIENT";
export const SHOW_ALERT_INFO_CHOOSE_PATIENT =
  "patient/SHOW_ALERT_INFO_CHOOSE_PATIENT";
export const HIDE_ALERT_INFO_CHOOSE_PATIENT =
  "patient/HIDE_ALERT_INFO_CHOOSE_PATIENT";
export const SHOW_WARNING_BHYT = "patient/SHOW_WARNING_BHYT";
export const HIDE_WARNING_BHYT = "patient/HIDE_WARNING_BHYT";
export const RESET_REDIRECT_TO_CHECK_PHONE =
  "patient/RESET_REDIRECT_TO_CHECK_PHONE";

// 06-02-2020 - Gom chung Patient
export const GET_MEDPRO_PATIENT_LIST = "patient/GET_MEDPRO_PATIENT_LIST";
export const GET_MEDPRO_PATIENT_LIST_SUCCESS =
  "patient/GET_MEDPRO_PATIENT_LIST_SUCCESS";
export const GET_MEDPRO_PATIENT_LIST_FAIL =
  "patient/GET_MEDPRO_PATIENT_LIST_FAIL";

export const GET_MEDPRO_PATIENT_SUGGESTION_LIST =
  "patient/GET_MEDPRO_PATIENT_SUGGESTION_LIST";
export const GET_MEDPRO_PATIENT_SUGGESTION_LIST_SUCCESS =
  "patient/GET_MEDPRO_PATIENT_SUGGESTION_LIST_SUCCESS";
export const GET_MEDPRO_PATIENT_SUGGESTION_LIST_FAIL =
  "patient/GET_MEDPRO_PATIENT_SUGGESTION_LIST_FAIL";

// Đang dùng
export const SELECT_PATIENT_REEXAM = "patient/SELECT_PATIENT_REEXAM";
export const SELECT_PATIENT_REEXAM_SUCCESS =
  "patient/SELECT_PATIENT_REEXAM_SUCCESS";

export const SELECT_PATIENT_FROM_LIST = "patient/SELECT_PATIENT_FROM_LIST";
export const SELECT_PATIENT_FROM_DATA = "patient/SELECT_PATIENT_FROM_DATA";

export const CHECK_INSURANCE = "patient/CHECK_INSURANCE";
export const CHECK_INSURANCE_SUCCESS = "patient/CHECK_INSURANCE_SUCCESS";
export const CHECK_INSURANCE_FAIL = "patient/CHECK_INSURANCE_FAIL";

export const VERIFY_PHONE_PATIENT = "patient/VERIFY_PHONE_PATIENT";
export const VERIFY_PHONE_PATIENT_SUCCESS =
  "patient/VERIFY_PHONE_PATIENT_SUCCESS";
export const VERIFY_PHONE_PATIENT_FAILURE =
  "patient/VERIFY_PHONE_PATIENT_FAILURE";

export const VERIRY_PATIENT_WITHOUT_PHONE =
  "patient/VERIRY_PATIENT_WITHOUT_PHONE";

export const VERIFY_INFO_PATIENT = "patient/VERIFY_INFO_PATIENT";
export const VERIFY_INFO_PATIENT_SUCCESS =
  "patient/VERIFY_INFO_PATIENT_SUCCESS";
export const VERIFY_INFO_PATIENT_FAILURE =
  "patient/VERIFY_INFO_PATIENT_FAILURE";

export const SAVE_FIELD_FORM_SEARH_PATIENT_BY_INFO =
  "patient/SAVE_FIELD_FORM_SEARH_PATIENT_BY_INFO";
export const SAVE_FIELD_FORM_CHECK_INSURANCE =
  "patient/SAVE_FIELD_FORM_CHECK_INSURANCE";
export const RESET_FORM_CHECK_INSURANCE = "patient/RESET_FORM_CHECK_INSURANCE";
export const UPDATE_FORM_CHECK_INSURANCE =
  "patient/UPDATE_FORM_CHECK_INSURANCE";
export const SCAN_QR_CODE_INSURANCE_SUCCESS =
  "patient/SCAN_QR_CODE_INSURANCE_SUCCESS";
export const RESET_STATUS_SCAN_QR_CODE_INSURANCE =
  "patient/RESET_STATUS_SCAN_QR_CODE_INSURANCE";

export const CHECK_INSURANCE_OF_PATIENT = "patient/CHECK_INSURANCE_OF_PATIENT";
export const CHECK_INSURANCE_OF_PATIENT_FAILED =
  "patient/CHECK_INSURANCE_OF_PATIENT_FAILED";
export const RESET_ERROR_CHECK_INSURANCE =
  "patient/RESET_ERROR_CHECK_INSURANCE";

export const REGESTER_INSURANCE = "REGESTER_INSURANCE";

export const POST_INFO_XNC = "POST_INFO_XNC";
export const SET_PATIENTID = "SET_PATIENTID";

export const SET_TYPE_CREATE_PATIENT = "SET_TYPE_CREATE_PATIENT";
